import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Tab } from '@shared';
import { reportTypes } from '../../constants';

@Component({
  selector: 'app-exceptions',
  templateUrl: './exceptions.component.html',
  styleUrl: './exceptions.component.scss',
})
export class ExceptionsComponent implements OnInit {
  selectedTabIndex: number = 0;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    const currentUrl = this.router.url;
    const matchIndex = this.tabs.findIndex(
      (tab) => currentUrl.includes(tab.contentUrl),
    );
    if (matchIndex >= 0) {
      this.selectedTabIndex = matchIndex;
      this.tabs[matchIndex].selected = true;
    }
  }

  tabs: Tab[] = Array.from(reportTypes.keys()).map((rt) => {
    return new Tab(rt, `${reportTypes.get(rt)}`);
  });

  onTabSelect(selectedTab: Tab) {
    this.selectedTabIndex = this.tabs.indexOf(selectedTab);

    this.tabs.forEach((tab) => {
      tab.selected = tab.name === selectedTab.name;
    });

    this.router.navigate([selectedTab?.contentUrl], {
      relativeTo: this.activatedRoute,
    });
  }
}
